/**
 * @file The Component contains the whole Configuration information for user to review their choices
 * @author Haonan Yu(haoyu@microStrategy.com)
 */
import React from 'react';
import { Button, Form, Icon, Input, Col, Row, Divider } from 'antd';
//funcs & data
import { generateLinuxFile } from '../../../../FileGenerator/FileGenerator';
import {
    state2PrefixMap,
    state2CommentMap,
} from '../../../../Utils/LinuxDataLoader';
import { triggerLambda, setFormFieldValue } from '../../../../Utils/utils';
import * as DEFINITIONS from '../../../../Utils/Constants';
import { getPageObjectByName } from '../../../../Utils/PageObjectsMapUtil';
//components
import ReferencePicture from '../../../ReferencePicture/ReferencePicture';
//css
import 'antd/dist/antd.css';
import '../../../../Utils/CommonCss.css';

const PAGE_NAME = DEFINITIONS.LIN_FINALPAGE;

class FinalPage extends React.Component {
    constructor(props) {
        super(props);
        this.formSections = getPageObjectByName(PAGE_NAME).formSections;
    }
    /**
     * Change the state of initialPage to go back to License Agreement page
     */
    backToLicensePage = () => {
        this.props.setBasicState('initialPage', true);
    };

    backStep = () => {
        this.backToLicensePage();
    };

    /**
     *
     * Generate a list of form JSX item based on given data
     * @param {Array} formInfo an array that contains necessary content for each form item
     * @return {Array} an array of form items that contain input boxes
     */
    generateFormContent = (formInfo) => {
        const { getFieldDecorator } = this.props.form;
        return formInfo.map((section, index) => (
            <Form.Item
                label={section.label}
                key={index}
                className={section.fieldName}
            >
                {getFieldDecorator(section.fieldName, {
                    rules: [
                        {
                            required: section.rules[0].required,
                            message: section.rules[0].message,
                            whitespace: section.rules[0].whitespace,
                            pattern: section.rules[0].pattern,
                        },
                    ],
                })(
                    <Input
                        onChange={(e) => {
                            this.props.setOriginState(
                                section.state,
                                e.target.value
                            );
                        }}
                    />
                )}
            </Form.Item>
        ));
    };

    /**
     * To generate the Options_Update1.txt and download it locally
     */
    downloadTxtFile = () => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                const element = document.createElement('a');
                let res = null;
                res = generateLinuxFile(
                    this.props,
                    state2PrefixMap,
                    state2CommentMap
                );

                let fileName;
                switch (this.props.useVersion) {
                    case DEFINITIONS.M2021_UPDATE1:
                        fileName = 'options_m2021_u1.txt';
                        break;
                    case DEFINITIONS.M2021_UPDATE2:
                        fileName = 'options_m2021_u2.txt';
                        break;
                    case DEFINITIONS.M2021_UPDATE3:
                        fileName = 'options_m2021_u3.txt';
                        break;
                    default:
                }

                let file = new File([res], fileName, {
                    type: 'text/plain',
                });

                element.href = URL.createObjectURL(file);
                element.download = file.name;
                document.body.appendChild(element); // Required for this to work in FireFox
                element.click();

                let info = {
                    fileName: file.name,
                    companyName: null, // no company name
                    os: this.props.useOs,
                    mode: this.props.useMode,
                    version: this.props.useVersion,
                };

                //upload to s3
                triggerLambda(
                    info,
                    function (response) {
                        console.log('Success!');
                    },
                    function (error) {
                        console.error(error);
                    }
                );
            }
        });
    };

    componentDidMount() {
        for (let formInfo of this.formSections.finalPageInputs) {
            setFormFieldValue(formInfo.fieldName, formInfo.state, this.props);
        }
    }

    render() {
        return (
            <Form className="form">
                <Row type="flex" align="top">
                    <Col span={16} className="colContent">
                        <div className="lin-update1-block">
                            <p className="headlineTop">
                                MicroStrategy Installation Selection
                            </p>
                            {this.generateFormContent(
                                this.formSections.finalPageInputs
                            )}
                        </div>
                    </Col>

                    <Divider
                        className="divider"
                        type="vertical"
                        orientation="right"
                    />
                    <Col span={7} className="colPics">
                        <p className="headlineTop">Reference Pictures</p>
                        <ReferencePicture
                            pageName={PAGE_NAME}
                            getOriginState={this.props.getOriginState}
                        />
                    </Col>
                </Row>
                <div className="buttonBar">
                    <div className="description">
                        You are creating a configuration file for
                        <img
                            src={require('../../../../assets/Icons/Linux.png')}
                            alt="Operating System"
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            className="buttonBack"
                            type="default"
                            onClick={this.backStep}
                        >
                            Back
                        </Button>
                        <Button
                            className="buttonNext"
                            type="primary"
                            onClick={this.downloadTxtFile}
                        >
                            <Icon type="vertical-align-bottom" />
                            Download File
                        </Button>
                    </div>
                </div>
            </Form>
        );
    }
}

const LinFinalPage = Form.create({ name: 'finalPage' })(FinalPage);

export default LinFinalPage;
